import { ViewComponentProps } from '@databases/fields/view/types';
import { DatabaseFieldType } from '@databases/types/database';
import React, { FunctionComponent } from 'react';

import SelectOptionTag from '../../SelectOptionTag';

const SelectValueView: FunctionComponent<
  ViewComponentProps<DatabaseFieldType.SELECT>
> = ({ field, value }) => {
  return (
    <>
      {field.settings.selectOptions.flatMap((option) => {
        if (!value.some((val) => val === (option.id ?? option.label))) {
          return [];
        }

        return [<SelectOptionTag key={option.id ?? option.label} option={option} />];
      })}
    </>
  );
};

export default SelectValueView;
